import { Link } from "react-scroll";
import { createSlug } from "../../utils/utils";

import classes from "./ArticleTOC.module.css";

interface TOCFactoryInterface {
  item: any;
  depth: number;
}

const TOCFactory = ({ item, depth }: TOCFactoryInterface) => {
  const children = item.children.length ? (
    <ul>
      {item.children.map((c: any) => (
        <TOCFactory item={c} depth={depth + 1} />
      ))}
    </ul>
  ) : (
    <></>
  );
  return (
    <>
      <li>
        <Link
          className={classes.tocLink}
          to={createSlug(item.number + " " + item.headline)}
          spy={true}
          smooth={false}
          dangerouslySetInnerHTML={{
            __html: item.number + " " + item.headline,
          }}
        />
        {depth < 2 && children}
      </li>
    </>
  );
};

interface TOCInterface {
  item: any;
  english?: boolean;
}

const TOC = ({ item, english }: TOCInterface) => {
  return (
    <>
      <h2>{english ? "Table of Contents" : "Obsah kapitoly"}</h2>
      <ul>
        {item.children.map((c: any) => (
          <TOCFactory key={item.depth} item={c} depth={1} />
        ))}
      </ul>
    </>
  );
};

export default TOC;
